import { Component } from 'react';
import PropTypes from 'prop-types';
import { loadTitle } from '../../../shared/actions/loadPdf';
/*
 * Note: this is an empty component used to set initial variables
 * */
export default class Init extends Component {
  async componentDidMount() {
    const {
      loadOutline, loadPdf, setClientSize, getEnhancements, attachHotkeyInterceptors, receivedToken,
    } = this.props;
    loadPdf()
      .then((pdfDoc) => {
        loadOutline(pdfDoc);
        loadTitle(pdfDoc);
      });

    setClientSize();
    getEnhancements();

    attachHotkeyInterceptors();
    window.addEventListener('load', this.addWindowEvents.bind(this));
    window.receivedToken = receivedToken;
  }

  shouldComponentUpdate() {
    return false;
  }

  addWindowEvents() {
    const { attachResizeListener } = this.props;
    attachResizeListener();
  }

  render() {
    return null;
  }
}

Init.propTypes = {
  attachHotkeyInterceptors: PropTypes.func.isRequired,
  attachResizeListener: PropTypes.func.isRequired,
  setClientSize: PropTypes.func.isRequired,
  getEnhancements: PropTypes.func.isRequired,
  loadOutline: PropTypes.func.isRequired,
  receivedToken: PropTypes.func.isRequired,
  loadPdf: PropTypes.func.isRequired,
};
